import { render, staticRenderFns } from "./alertsMessage.vue?vue&type=template&id=2605f236&scoped=true&"
import script from "./alertsMessage.vue?vue&type=script&lang=js&"
export * from "./alertsMessage.vue?vue&type=script&lang=js&"
import style0 from "./alertsMessage.vue?vue&type=style&index=0&id=2605f236&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2605f236",
  null
  
)

export default component.exports